import { defineMessage, FormattedMessage } from 'react-intl'

import { Currency } from '@/constants/currency'
import { getFlagUrlByCurrency } from '@/lib/images'
import { formatCurrency } from '@/lib/money'
import { ChevronRight } from '@/shared/icons/outline'
import { Button, Card, SlideInScreen, Typography } from '@/shared/ui'

const ACCOUNT_OPTIONS = [
  {
    currency: Currency.USDC,
    description: defineMessage({
      id: 'createAccount.selectType.USDC.description',
      defaultMessage: 'To receive payments from the USA and Mexico',
    }),
  },
  {
    currency: Currency.EURC,
    description: defineMessage({
      id: 'createAccount.selectType.EURC.description',
      defaultMessage: 'To receive payments from Europe and Mexico',
    }),
  },
] as const

type Props = {
  onContinue: (currency: Currency) => void
}

export const SelectCurrencyStep = ({ onContinue }: Props) => {
  return (
    <SlideInScreen>
      <Typography text="center" variant="h3">
        <FormattedMessage
          defaultMessage="Create a new account"
          id="createAccount.selectCurrency.title"
        />
      </Typography>

      <div className="p-2" />

      <Typography text="center">
        <FormattedMessage
          defaultMessage="Choose the currency for your new account"
          id="createAccount.selectCurrency.subtitle"
        />
      </Typography>

      <div className="p-6" />

      <div className="flex flex-col gap-3">
        {ACCOUNT_OPTIONS.map((option) => (
          <Card
            size="medium"
            className="flex w-full items-center justify-between"
            key={option.currency}
            asChild
            scalable
          >
            <Button
              size="inline"
              variant="ghost"
              onClick={() => onContinue(option.currency)}
            >
              <div className="flex items-center gap-3">
                <img
                  src={getFlagUrlByCurrency(option.currency)}
                  className="size-9 shrink-0"
                  alt=""
                  aria-hidden
                />

                <div className="flex flex-col">
                  <Typography bold>
                    {formatCurrency(option.currency)}
                  </Typography>
                  <Typography
                    variant="body-small"
                    className="text-neutral-gray-600"
                  >
                    <FormattedMessage {...option.description} />
                  </Typography>
                </div>
              </div>

              <ChevronRight className="text-neutral-gray-600 size-6 shrink-0" />
            </Button>
          </Card>
        ))}
      </div>
    </SlideInScreen>
  )
}
